import type { PathValue, RecursiveKeys, WithoutIndexSignature } from '../types';

import { parseStringValue } from './parseStringValue';

export class TypedConfig<TConfig> {
  constructor(
    readonly delegate: {
      get<T>(key?: string): T;
      getOptional<T>(key?: string): T | undefined;
    },
  ) {}

  get<Key extends RecursiveKeys<WithoutIndexSignature<TConfig>>>(
    key: Key,
  ): PathValue<TConfig, Key> {
    const value = this.delegate.get<PathValue<TConfig, Key>>(key);
    return parseStringValue(value);
  }

  getOptional<Key extends RecursiveKeys<WithoutIndexSignature<TConfig>>>(
    key: Key,
  ): PathValue<TConfig, Key> | undefined {
    const value = this.delegate.getOptional<PathValue<TConfig, Key>>(key);
    return value === undefined ? undefined : parseStringValue(value);
  }
}
